import { render, staticRenderFns } from "./BackgroundCustoms.vue?vue&type=template&id=2131c6c0"
import script from "./BackgroundCustoms.vue?vue&type=script&lang=js"
export * from "./BackgroundCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports